import './_reporter'

import { initSdk } from '@shopee/web-bridge-sdk'
import React, { Suspense, useLayoutEffect, useState, StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { Navigate } from 'react-router-dom'
import FontFaceObserver from 'fontfaceobserver'
import { HelmetProvider } from 'react-helmet-async'

// Antd Styles
import './Common/AntdStyles/antd.less'

// Styles
import './Common/Theme/Fonts/fontLoader.less'

// App
import { Navbar } from 'src/Common/Components/Navbar'
import { AppFooter } from 'src/Common/Components/AppFooter'
import { StickyBar } from './Common/Components/StickyBar'
import { Loading } from 'src/Common/Components/Loading'

// Navigation
import { NAVIGATION_ROUTES } from './Navigation'

// Redux
import { store } from './RootRedux'
import { ContactDetailsBar } from './Common/Components/ContactDetailsBar'
import './style.less'

// =============== Pre load ===============
const LoadApp = (props) => {
  // State
  // ------------------
  const [Loaded, setLoaded] = useState(false)

  // Effects
  // ------------------
  useLayoutEffect(() => {
    initSdk()
    ;(async () => {
      const promises = []
      promises.push(loadFontAsync('Open Sans'))
      promises.push(loadFontAsync('Open Sans SemiBold'))
      promises.push(loadFontAsync('Shopee_font Bold'))
      promises.push(loadFontAsync('Shopee_font Medium'))
      promises.push(loadFontAsync('Shopee_font'))
      promises.push(loadFontAsync('Roboto Bold'))
      promises.push(loadFontAsync('Roboto Medium'))
      promises.push(loadFontAsync('Roboto Regular'))
      await Promise.allSettled(promises)
      setLoaded(true)
    })()
  }, [])

  // Method
  // ------------------
  const loadFontAsync = (fontFamily) =>
    new Promise((res, rej) => {
      const font = new FontFaceObserver(fontFamily)
      font.load().then(res).catch(rej)
    })
  return Loaded ? props.children : null
}

const rootElement = document.getElementById('root')
const root = createRoot(rootElement)

root.render(
  <LoadApp>
    <StrictMode>
      <Provider store={store}>
        <HelmetProvider>
          <Router
            basename={
              process.env.PUBLIC_URL && process.env.PUBLIC_URL !== '.'
                ? process.env.PUBLIC_URL
                : '/'
            }
          >
            <Navbar />
            <ContactDetailsBar />
            <StickyBar />
            <Suspense fallback={<Loading />}>
              <Routes>
                {Object.values(NAVIGATION_ROUTES).map((route, idx) => (
                  <Route key={idx} {...route} />
                ))}
                <Route
                  path="/contactus"
                  element={<Navigate to="/lien-he-chung-toi" />}
                />
                <Route path="/gioi-thieu" element={<Navigate to="/" />} />
                <Route
                  path="/hop-tac-doanh-nghiep"
                  element={<Navigate to="/" />}
                />
                <Route path="/dich-vu" element={<Navigate to="/" />} />
                <Route path="/tin-tuc" element={<Navigate to="/" />} />
                <Route path="/tin-tuc/*" element={<Navigate to="/" />} />
              </Routes>
            </Suspense>
            <AppFooter />
          </Router>
        </HelmetProvider>
      </Provider>
    </StrictMode>
  </LoadApp>
)
